import React from "react";
import { AwsFileUploadGenericPath } from "../utils/constant";
import "./FilePreview.css";

const FilePreview = ({ ...props }) => {
  const getFileName = (fileLink = "") => {
    const rawFileName = fileLink.split("/").pop()?.split("?")[0] || "download";

    try {
      return decodeURIComponent(rawFileName);
    } catch (error) {
      return rawFileName;
    }
  };

  const fileName = getFileName(props.fileLink);
  const fileExtension = fileName.includes(".")
    ? fileName.split(".").pop().toLowerCase()
    : "";

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];

  // Mapping of file extensions to their respective icons
  const fileIcons = {
    pdf: `${AwsFileUploadGenericPath}icons8-pdf-48.png`,
    doc: `${AwsFileUploadGenericPath}docx.png`,
    docx: `${AwsFileUploadGenericPath}docx.png`,
    txt: `${AwsFileUploadGenericPath}pptx-file.png`,
  };

  const downLoadFile = () => {
    console.log("props?.isDownloadable", props?.isDownloadable);
    if (!!props?.isDownloadable) {
      const fileUrl = props.fileLink;
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const downloadUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = fileName;
          link.click();
          URL.revokeObjectURL(downloadUrl);
        })
        .catch((error) => {
          console.error("Download failed:", error);
        });

      // window.open(props.fileLink, '_blank');
    }
  };

  const handleDownloadClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    downLoadFile();
  };

  const handleCloseClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    props.setFileURL(null);
  };

  const isImage = imageExtensions.includes(fileExtension);
  const fileTypeLabel = fileExtension ? fileExtension.toUpperCase() : "FILE";
  const previewClassName = [
    "fileattach-wrap",
    "filepreview",
    props?.isDownloadable ? "filepreview--downloadable" : "",
  ]
    .filter(Boolean)
    .join(" ");
  const surfaceClassName = [
    "filepreview__surface",
    isImage ? "filepreview__surface--image" : "filepreview__surface--file",
    props?.closeButton && !isImage ? "filepreview__surface--with-close" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={previewClassName}
      onClick={downLoadFile}
      style={{
        cursor: props?.isDownloadable ? "pointer" : "default",
        gap: props?.showDownloadButton ? "10px" : 0,
      }}
    >
      <div className="filepreview__item">
        {!!props.closeButton && (
          <button
            type="button"
            className="filepreview__close"
            onClick={handleCloseClick}
            aria-label="Remove attachment"
          >
            X
          </button>
        )}

        {isImage ? (
          <div className={surfaceClassName}>
            <img
              className="filepreview__image"
              src={props.fileLink}
              alt={fileName || "Preview"}
              loading="lazy"
            />
          </div>
        ) : (
          <div className={surfaceClassName}>
            <span className="filepreview__icon" aria-hidden="true">
              <img
                src={
                  fileIcons[fileExtension] ||
                  `${AwsFileUploadGenericPath}all-file.png`
                }
                alt=""
              />
            </span>
            <div className="filepreview__meta">
              <span className="filepreview__type">{fileTypeLabel}</span>
              <p className="filepreview__name" title={fileName}>
                {fileName}
              </p>
            </div>
          </div>
        )}
      </div>

      {!!props?.showDownloadButton && (
        <button
          type="button"
          className="filepreview__download"
          onClick={handleDownloadClick}
        >
          Download
        </button>
      )}
    </div>
  );
};

export default FilePreview;
